export function onlyOneIsNull(a, b) {
    return (a == null && b != null) || (a != null && b == null);
}
export function chooseAmong(values, sortFunction, allowNull) {
    let eligibleValues = values;
    if (!allowNull) {
        eligibleValues = values.filter((value) => value != null);
    }
    return eligibleValues.sort(sortFunction)[0];
}
export function preferNull(sortFunction) {
    return (a, b) => {
        if (a == null) {
            return -1;
        }
        if (b == null) {
            return 1;
        }
        return sortFunction(a, b);
    };
}
export function sortByLocaleString(list, transform, options = { sensitivity: 'base' }) {
    return [...list].sort((a, b) => transform(a).localeCompare(transform(b), undefined, options));
}
export function notEmpty(value) {
    return value !== null && value !== undefined;
}
export function notFalse(value) {
    return value !== false;
}
export function parseIntOrNull(stringValue) {
    const intValue = parseInt(stringValue, 10);
    if (Number.isNaN(intValue)) {
        return null;
    }
    return intValue;
}
export function parseFloatOrNull(stringValue) {
    const floatValue = parseFloat(stringValue);
    if (Number.isNaN(floatValue)) {
        return null;
    }
    return floatValue;
}
//# sourceMappingURL=ValueUtils.js.map